<template>
  <main class="pp-page--payment">
    <h1 class="title title--desktop">{{ $t("payment.payment_details") }}</h1>
    <div class="pp-layout-container pp-layout-container--single">
      <div class="pp-preamble">
        <h1 class="title title--mobile">{{ $t("payment.payment_details") }}</h1>
      </div>
      <section class="pp-main-content">
        <form :action="getFormAction()" method="POST">
          <div v-if="showComplementary">
            <p v-t="'payment.no_cost'"/>
            <input type="hidden" name="gateway" :value="'complimentary'" />
          </div>
          <payment-radios 
            v-else
            :paymentOptions="getPaymentOptionList()"
            @newValue="selectPaymentType"
          />
          <input type="hidden" name="cartGuid" :value="cart.cartGuid" />
          <input type="hidden" name="language" :value="$i18n.locale" />
          <input type="hidden" name="deliveryCode" :value="getDeliveryOption.code" />
          <input type="hidden" name="postcode" :value="user.deliveryDetails.postcode" />
          <input type="hidden" name="country_code" :value="user.deliveryDetails.country_code" />
          <input type="hidden" name="deliveryAddress1" :value="user.deliveryDetails.deliveryAddress1" />
          <input type="hidden" name="deliveryAddress2" :value="user.deliveryDetails.deliveryAddress2" />
          <input type="hidden" name="deliveryAddress3" :value="user.deliveryDetails.deliveryAddress3" />
          <input type="hidden" name="newsletter" :value="user.newsletterState" />

          <div class="pp-actions">
            <div class="pp-actions__container">
              <fancy-button :type="'submit'" :icon="['far', 'ticket-alt']" :disabled="paymentSubmitDisabled">{{ $t("buttons.ok_continue") }}</fancy-button>
            </div>
          </div>
        </form>
      </section>
    </div>
  </main>
</template>

<script>
import FancyButton from "@/components/generic/FancyButton";
import { mapState, mapGetters, mapActions } from "vuex";
import PaymentRadios from "@/components/shopping-cart/PaymentRadios";
import _ from "lodash"

export default {
  name: "payment",
  data() {
    return {
      paymentTypeSelected: null
    }
  },
  components: {
    FancyButton,
    PaymentRadios,
  },
  mounted() {
    // Setting loading to true when we click checkout on shopping cart
    this.updateStage("payment")
    this.updateLoading(false)
  },
  computed: {
    paymentSubmitDisabled() {
      // No payment required, don't disable
      if(this.showComplementary) {
        return false;
      }

      // No payment method selected
      if (this.paymentTypeSelected == null) {
        return true
      }

      return false;
    },
    ...mapState(["cart", "user"]),
    ...mapGetters(["getDeliveryOption", "getPaymentOption", "showComplementary"]),
  },
  methods: {
    getFormAction() {
      return (
        process.env.VUE_APP_WK_INTEGRATION_LAYER + "/api/v0/sistic/payment"
      );
    },
    getPaymentOptionList() {
      return {
        name: "gateway",
        options: this.getPaymentOption,
      };
    },
    getDeliveryInformation() {
      let info = this.user.deliveryDetails;

      return info
    },
    selectPaymentType(e) {
      this.paymentTypeSelected = e;
    },
    ...mapActions(['updateLoading', 'updateStage'])
  },
};
</script>